import React from "react";
import { get } from "lodash";
import styled from "styled-components";
import { useState, useEffect } from "react";
import { twdClass } from "../../../constants/tailwind.constants";
import "@uppy/core/dist/style.css";
import "@uppy/drag-drop/dist/style.css";
import { UPLOADTO_S3 } from "../../../api/endpoint.urlconstants";
import { INPUT_TEXT } from "../../../constants/var.constants";
import S3Uploader from "./S3Uploader";

const ImageUploader = ({ element, data, updateElementValue, inputArgs  }) => {
  const [value, setValue] = useState();
  const { updateTo, defaultValue, label } = element;
  const { action, display_label, display_row=false, inputStyle } = inputArgs;
  

  useEffect(() => {
    const dataValue = get(data, updateTo);
    const value = dataValue ? dataValue : defaultValue;
    setValue(value);
  }, [get(data, updateTo)]);

  const updateImagePath = (url) => {
    setValue(url);
    updateElementValue(updateTo, url);
  };

  let CL_LABEL_WRAP = `flex items-center mb-2`;
  let CL_LABEL = " pb-1 px-1 flex-grow text-gray-900";
  CL_LABEL += display_row ? " w-20" : " ";
  let CL_ACTION = " text-sm";


  return (
    <ImgContainer>
      <div className={twdClass(`${CL_LABEL_WRAP}`)}>
        <div className={twdClass(`${CL_LABEL} font-semibold text-xs`)}>
          {display_label && label}
        </div>
        <div className={twdClass(CL_ACTION)}>{action && action}</div>
      </div>
      <S3Uploader imageUrl={value} updateS3Path={updateImagePath} />
      <input
        className={twdClass(`w-full mt-2 bg-white ${INPUT_TEXT}`)}
        value={value}
        onChange={(e) => {
          updateElementValue(updateTo, e.target.value);
          setValue(e.target.value);
        }}
      />
    </ImgContainer>
  );
};

export default ImageUploader;

const ImgContainer = styled.div`
  .uppy-DragDrop-inner {
    padding: 0px;
  }
  .uppy-DragDrop-arrow {
    height: 22px;
    width: 20px;
    margin-bottom: 0px;
  }
  .uppy-DragDrop-label {
    font-size: 0.75rem;
  }
`;
